(function(){
  var css = '.ev-labelrow{display:flex !important;flex-wrap:wrap;justify-content:space-between;align-items:center}.ev-labelrow .select{flex:0 0 100%}.ev-guide{display:inline-flex;align-items:center;gap:.6rem;font-size:1.4rem;color:#1a1a1a;text-decoration:underline;text-underline-offset:.3rem;white-space:nowrap}.ev-guide svg{width:1.8rem;height:1.8rem}';
  var st = document.createElement('style'); st.textContent = css; document.head.appendChild(st);
  var ruler = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><rect x="2" y="8" width="20" height="8" rx="1.5"></rect><path d="M6 8v3M10 8v4M14 8v3M18 8v4"></path></svg>';
  function add(){
    var labels = document.querySelectorAll('.product__info-container .product-form__input label.form__label');
    labels.forEach(function(l){
      var t = (l.textContent || '').trim().toLowerCase();
      var href = null, text = null;
      if (t === 'ring size') { href = '/pages/ring-size-guide'; text = 'Size Guide'; }
      else if (t === 'carat') { href = '/pages/carat-size-guide'; text = 'Carat Guide'; }
      if (!href) return;
      var row = l.parentElement;
      if (!row || row.querySelector('.ev-guide')) return;
      row.classList.add('ev-labelrow');
      var a = document.createElement('a');
      a.className = 'ev-guide'; a.href = href; a.innerHTML = ruler + '<span>' + text + '</span>';
      l.insertAdjacentElement('afterend', a);
    });
  }
  function init(){
    add();
    var c = document.querySelector('.product__info-container') || document.body;
    var busy = false;
    new MutationObserver(function(){ if (busy) return; busy = true; setTimeout(function(){ add(); busy = false; }, 120); }).observe(c, {childList: true, subtree: true});
  }
  if (document.readyState !== 'loading') init(); else document.addEventListener('DOMContentLoaded', init);
})();
